import { Box, Button, Alert, Typography, useTheme } from "@mui/material";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { useAuth } from "../context/AuthContext";

const DEFAULT_MESSAGE =
  "An account already exists for this email. Sign in with the original method or contact support to link this sign-in method.";

export default function AccountLinkRequiredPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { currentUser, sessionIssueMessage } = useAuth();

  const returnToLogin = async () => {
    await signOut(auth);
    navigate("/login", { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "background.default",
        px: 2,
      }}
    >
      <Box sx={{ maxWidth: 480, width: "100%", p: 4 }}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Account sign-in needs attention
        </Typography>
        <Alert severity="warning" sx={{ mb: 3 }}>
          {sessionIssueMessage ?? DEFAULT_MESSAGE}
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {currentUser?.email
            ? `You are currently signed in as ${currentUser.email}.`
            : "This sign-in method is not linked to a Setin portal account."}
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={returnToLogin}
          sx={{ mb: 1.5 }}
        >
          Sign in another way
        </Button>
        <Typography
          variant="caption"
          sx={{ color: theme.palette.text.secondary, display: "block" }}
        >
          If this should be your account, contact support before creating a new
          business.
        </Typography>
      </Box>
    </Box>
  );
}
